import { useEffect, useRef, useState } from "react";
import { useInView } from "framer-motion";
import { Flotante, FotoRevelada } from "@/components/Reveal";

// Media grande por dron: video propio en bucle (solo cuando entra en pantalla,
// sin sonido) con foto de portada; foto fija si no hay video o si el usuario
// tiene «reducir movimiento» activado; panel azul marino mientras no haya
// material propio del modelo (T55). El recorte transparente del dron entra
// subiendo y queda flotando suavemente. Las fotos de las ramas fotográficas
// entran con cortina y leve acercamiento.
export default function MediaDrone({ drone }) {
  if (drone.media === "panel") {
    return (
      <div
        data-testid={`drone-media-${drone.slug}`}
        className="relative flex aspect-[16/9] w-full flex-col items-center justify-center overflow-hidden border border-hud bg-[#0c295c]/60"
      >
        <span
          className="pointer-events-none absolute inset-0 opacity-[0.07]"
          style={{ background: "radial-gradient(circle at 50% 120%, #52c234 0%, transparent 60%)" }}
          aria-hidden="true"
        />
        <img src="/logo-color.svg" alt="" aria-hidden="true" className="h-10 w-auto opacity-90 sm:h-12" loading="lazy" />
        {drone.producto ? (
          <Flotante className="mt-4 flex w-full justify-center sm:mt-6">
            <img
              src={drone.producto}
              alt={`Vista frontal oficial del ${drone.modelo}`}
              loading="lazy"
              decoding="async"
              className="w-[70%] max-w-[560px] drop-shadow-[0_18px_30px_rgba(0,0,0,0.45)]"
            />
          </Flotante>
        ) : (
          <p className="mt-4 font-mono text-[10px] uppercase tracking-[0.25em] text-smoke">Fotografía oficial próximamente</p>
        )}
        <p className={`px-4 text-center font-display font-extrabold uppercase tracking-tight text-mist ${drone.producto ? "mt-2 text-2xl sm:text-3xl lg:text-4xl" : "mt-5 text-3xl sm:text-4xl lg:text-5xl"}`}>
          {drone.modelo}
        </p>
        {drone.producto && (
          <p className="mt-2 font-mono text-[9px] uppercase tracking-[0.2em] text-smoke/70">Imagen: DJI Agriculture</p>
        )}
      </div>
    );
  }

  return <RamaMedia drone={drone} />;
}

function RamaMedia({ drone }) {
  const wrapRef = useRef(null);
  const vidRef = useRef(null);
  const [reduce, setReduce] = useState(false);
  const inView = useInView(wrapRef, { margin: "240px 0px 240px 0px" });

  useEffect(() => {
    setReduce(window.matchMedia("(prefers-reduced-motion: reduce)").matches);
  }, []);

  useEffect(() => {
    const v = vidRef.current;
    if (!v) return;
    if (inView) v.play().catch(() => {});
    else v.pause();
  }, [inView]);

  return (
    <div ref={wrapRef} data-testid={`drone-media-${drone.slug}`} className="relative overflow-hidden border border-hud bg-ink">
      {drone.videoLoop && !reduce ? (
        <video
          ref={vidRef}
          data-testid={`drone-video-${drone.slug}`}
          src={drone.videoLoop}
          poster={drone.img}
          muted
          loop
          playsInline
          preload="none"
          aria-label={drone.alt}
          className="aspect-[16/9] w-full object-cover"
        />
      ) : (
        <FotoRevelada
          src={drone.img}
          alt={drone.alt}
          parallax
          className="aspect-[16/9] w-full"
        />
      )}
      <span className="absolute left-4 top-4 border border-certero/60 bg-ink/80 px-3 py-1.5 font-mono text-[10px] uppercase tracking-[0.25em] text-certero backdrop-blur-sm">
        {drone.tag}
      </span>
    </div>
  );
}
